import { Reveal } from "@/lib/motion";
import { SectionHeading } from "@/components/PageIntro";

const MILESTONES = [
  { t: "iOS App Store Release", d: "FestivalPlan ist offiziell im App Store verfügbar.", color: "#22C55E" },
  { t: "Android Google Play Release", d: "Seit Oktober 2026 ist FestivalPlan offiziell im Google Play Store verfügbar.", color: "#22C55E" },
];

export default function Roadmap() {
  return (
    <section id="roadmap" data-testid="roadmap-section" className="border-b border-white/10">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 px-5 py-20 lg:grid-cols-[1fr_1.2fr] lg:gap-20 lg:px-8 lg:py-24">
        <Reveal>
          <SectionHeading eyebrow="Roadmap" title={<>Was <span className="text-gradient">2026</span> kommt.</>} />
        </Reveal>
        <Reveal delay={0.05}>
          <ol className="border-l border-white/10">
            {MILESTONES.map((m) => (
              <li key={m.t} className="relative pb-8 pl-8 last:pb-0">
                <span className="absolute -left-[5px] top-2 h-[9px] w-[9px] rounded-full" style={{ background: m.color }} />
                <h3 className="font-display text-lg font-semibold text-white">{m.t}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-white/55">{m.d}</p>
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
    </section>
  );
}
